import React from 'react'
import './RecCoaches.css'

const RecCoaches = ({ CoachData }) => {
    const colorMapping = {
        RED : 'red',
        ORANGE: 'darkorange',
        BLACK: 'black',
        GREEN: 'green',
        BLUE: 'blue',
        PURPLE: 'purple',
        ORION_1: 'red',
        ORION_2: 'black',
        SHERRARD_1: 'purple',
        SHERRARD_2: 'orange',
        YELLOW: 'darkorange'
    }

    return (
        <div className="app__coach-container">
             <h4 className="coach__title">Coaching Staff Spring 2025</h4>
            
            <table className="app__recCoaches_table">
                <thead className="app__recrCoaches_hd">
                    <tr className="app__recrCoaches_tr">
                        <th className="app__recCoaches_th">Age Group</th>
                        {/* <th className="app__recCoaches_th">Coach</th> */}
                        <th className="app__recCoaches_th">Team</th>
                    </tr>
                </thead>
                <tbody className="app__recCoaches_tbody">
                    {CoachData.map((row, index) => (
                        <tr className="app__recreactionCoaches_tr" key={index}>
                            <td className="recTeam">{row.ageGroup}</td>
                            {/* <td className="recTeam">{row.coachName}</td> */}
                            <td className="recTeam" style={{ color: colorMapping[row.teamColor]}}>{row.teamColor}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            
        </div>
    )
}

export default RecCoaches